import { Hub } from '@aws-amplify/core';
import { BACKEND_ERROR_EVENT } from 'vince-core/constants/errors';

const parseBackendErrorText = (backedErrorText: string): string => {
    let errorText = backedErrorText;
    if (errorText.startsWith('{') && errorText.endsWith('}')) {
        try {
            // Backend returns some totally crazy wrongly formatted json - attempting to fix
            const jsonText = errorText.replace('"",', '",').replace(':" "', ':"');
            const parsedResponse = JSON.parse(jsonText);

            if (Object.hasOwn(parsedResponse, 'validationError')) {
                errorText = parsedResponse.validationError;
            } else if (Object.hasOwn(parsedResponse, 'message')) {
                errorText = parsedResponse.message;
            } else if (Object.hasOwn(parsedResponse, 'error')) {
                errorText = parsedResponse.error;
            }
        } catch (ignore) {}
    }

    return errorText;
};

export const formatBackendError = (error: unknown, fallback: string): string => {
    const response = (error as { response?: { status?: number; _data?: unknown } })?.response;
    const data = response?._data;
    let message = fallback;

    if (typeof data === 'string') {
        message = parseBackendErrorText(data);
    } else if (data && typeof data === 'object') {
        const errorData = data as { validationError?: string; message?: string; error?: string };
        message = errorData.validationError || errorData.message || errorData.error || JSON.stringify(data);
    } else if (error instanceof Error && error.message) {
        message = error.message;
    }

    return response?.status ? `${response.status}: ${message}` : message;
};

export const handleBackendError = (backedErrorText: string, status: number) => {
    const errorText = parseBackendErrorText(backedErrorText);

    Hub.dispatch(
        BACKEND_ERROR_EVENT,
        {
            event: BACKEND_ERROR_EVENT,
            data: {
                message: errorText,
                status
            }
        }
    );
};
